import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "./i18n.js";

ReactDOM.render(
    <App />,
  document.getElementById('root')
);
document.body.style= 'background-color:#FFFFFF; margin:0 auto; padding:0;';
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//v1.0.6
serviceWorker.unregister();
